<style scoped>
    .item-td {
        cursor: pointer
    }
</style>
<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <label-component fontSize="30" fontWeight="bold">ユーザー定義の書類情報の編集</label-component>
            </v-col>
            <v-col cols="12"></v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat>
                    <v-container>
                        <ValidationObserver ref="obs" v-slot="{ invalid }">
                            <div v-for="n of 10" :key="n">
                                <ValidationProvider :name="'項目名' + n" :rules="{required:selectValues[n-1] != 0, max:255}" v-slot="{ errors }">
                                    <v-row>
                                        <v-col cols="2">
                                            <label-component>項目名{{n}}</label-component>
                                        </v-col>
                                        <v-col >
                                            <v-text-field v-model="itemNames[n-1]" placeholder="社内の運用に併せて項目名を設定してください" :counter="255" :error-messages="errors" outlined v-disabled-icon-focus background-color="white"></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-select
                                                v-model="selectValues[n-1]"
                                                :items="selects"
                                                outlined
                                                background-color="white"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </ValidationProvider>
                            </div>
                            <v-row justify="center">
                                <v-col cols="12" class="text-center">
                                    <button-component @click="clickSave" color="red accent-3" :disabled="invalid">保存</button-component>
                                </v-col>
                            </v-row>
                        </ValidationObserver>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
        <!-- メッセージ -->
        <message-component id="message" v-model="isMessage" :success="message.success">{{ message.text }}</message-component>
    </v-container>
</template>
<script>
    import { required, } from 'vee-validate/dist/rules';
    import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
    
    const USE_NO = 0;
    const USE_REQUIRED = 1;
    const USE_ANY = 2;

    export default {
        data() {
            return {
                selectValues: Array(10),
                selects: [
                    { text: '使用しない' , value: USE_NO } ,
                    { text: '必須項目として使用する' , value: USE_REQUIRED } ,
                    { text: '任意項目として使用する' , value: USE_ANY } ,
                ],
                message: {
                    success: false,
                    text: "",
                },
                itemNames: Array(10),
                disabledBtn: false,
            }
        },
        props: {
            userDefinedItems: Array,
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        created() {
            this.selectValues.fill(USE_NO);
            this.itemNames.fill(null);
            for (let i = 0; i < 10; i++) {
                if (this.userDefinedItems[i]){
                    this.itemNames[i] = this.userDefinedItems[i]['item_name'];
                    this.selectValues[i] = this.userDefinedItems[i]['is_required'];
                }
            }
        },
        methods: {
            prevPage() {
                history.back();
            },
            clickSave() {
                this.disabledBtn = true;
                let itemVals = [];
                for (let i = 0; i < 10; i++) {
                    itemVals.push({ item_name: this.itemNames[i], is_required: this.selectValues[i] });
                }
                
                axios.post('/documents/document-management/save-user-defined', {
                    item_vals : itemVals,
                }).then(res => {
                    if (res.data.success) {
                        this.message.text = res.data.message;
                        this.message.success = true;
                    } else {
                        this.message.text = res.data.message;
                        this.message.success = false;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                }).finally(() => {
                    this.disabledBtn = false;
                });
            },
        }
    }
</script>
